<template>
  <v-container id="project-costs" fluid tag="section" class="main-container">
    <idc-component-bid-costings
      :bid-number="bidNumber"
      :settings="settings"
      :specifications="specifications"
      :center-coordinates="centerCoordinates"
      :summary="summary"
      :calculated="calculated"
      :totals="totals"
      :is-readonly="true"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapState, mapMutations } from 'vuex'
  import BidNumber from '@/utilities/bid/BidNumber'
  import RouteQuery from '@/utilities/core/route/RouteQuery'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'DashboardBidCostings',
    components: {
      IdcComponentBidCostings: () => import('@/components/idc/bids/cost/Costings'),
    },
    data: () => ({}),
    computed: {
      ...mapState('Settings', ['settings']),
      ...mapState('Bid', ['specifications', 'bidNumber', 'centerCoordinates', 'summary']),
      ...mapState('Bid/Cost', ['calculated', 'totals']),
    },
    mounted() {
      this.resetAll()
      this.initBidNumber()
    },
    methods: {
      ...mapActions('Bid', ['fetchSpecifications', 'fetchSummary']),
      ...mapActions('Project/Overview', ['fetchCostings']),
      ...mapMutations('Bid', ['setBidNumber']),
      ...mapMutations('Bid/Cost', ['resetAll', 'setCalculated', 'setConstants']),
      initBidNumber() {
        const bidNumber = new BidNumber()
        const num = RouteQuery.bidNumber(this.$router) ?? this.bidNumber ?? bidNumber.getFirst()

        this.setBidNumber(num)

        this.fetchSummary({ bidNumber: num })
        this.fetchSpecifications(num)

        this.fetchCostings({ bidNumber: num, record: parseInt(this.$router.currentRoute.query?.record) })
          .then(resp => {
            this.setCalculated(resp.calculated)
            this.setConstants(resp.constants)
          })
          .catch(() => {
            this.$router.push({ path: `${Path.PROJECTS_OVERVIEW}/${this.bidNumber}` })
          })
      },
    },
  })
</script>
